import { connect } from 'react-redux';

import {
  getFilterOptions,
  resetCardFilters,
  setFilters,
} from 'feature/loading-management/filters/store/filtersSlice';
import FilterPopover from './FilterPopover';

import { getAllCards, getApplicableFilters } from '../store/myAuthorizationsSlice';

const mapState = state => ({
  filters: getApplicableFilters(state),
  inventoryOwnerOptions: getFilterOptions(state, ['inventoryOwner', 'nameShort'], getAllCards),
  locationOptions: getFilterOptions(state, ['location', 'nameShort'], getAllCards),
  myAuthorizationPending: state.loadingManagement.myAuthorizations.myAuthorizationPending,
  productOptions: getFilterOptions(state, ['product', 'nameShort'], getAllCards),
  stateOptions: getFilterOptions(state, ['location', 'state'], getAllCards),
});

const mapDispatch = {
  resetCardFilters,
  setFilters,
};

export default connect(mapState, mapDispatch)(FilterPopover);
